<style lang="less" scoped>

</style>

<template lang="pug">
  img(
    :src='`/static/letters/${type}/${text}.png`'
    :width='width')
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'red',
    },
    text: {
      type: String,
    },
    width: {
      type: Number,
      default: 44,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/letter_panel.vue